"use client"

import { ArrowLeft } from "react-feather"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import { type PropertyModels, propertyApi } from "@/api/client/property"
import { PropertyForm, type PropertyFormSubmitValues } from "@/components/properties/PropertyForm"
import { IconButton } from "@/components/ui/icon-button/icon-button"

export function PropertyAddPage() {
  const navigate = useNavigate()

  const propertyCreateMutation = propertyApi.usePropertyCreate({
    mutation: {
      onSuccess: () => {
        toast.success("物件情報を登録しました。")
      },
    },
  })

  const handleSubmit = async (values: PropertyFormSubmitValues) => {
    try {
      await propertyCreateMutation.mutateAsync({
        data: values as unknown as PropertyModels.PropertyCreateBody,
      })
      navigate("/properties", {
        state: { shouldRefetch: true },
      })
    } catch (error) {
      console.error("Error submitting property:", error)
    }
  }

  return (
    <>
      <div className="flex items-center gap-3 mb-6">
        <IconButton variant="outline" size="back" onClick={() => navigate("/properties")}>
          <ArrowLeft className="h-4 w-4" />
        </IconButton>
        <h1 className="text-xl font-semibold text-slate-900">物件情報の登録</h1>
      </div>

      <div className="space-y-6">
        <PropertyForm
          onSubmit={handleSubmit}
          onCancel={() => navigate("/properties")}
          isSubmitting={propertyCreateMutation.isPending}
        />
      </div>
    </>
  )
}
